<template>
    <div id="Evaluation">
        <el-row class="full_height">
            <el-col :span="4" class="positon_relative">
                <el-menu class="nav_menu" text-color="#A7CCF6" default-active="1" active-text-color="#fff">
                    <router-link to="/EvaluationFirst" class="link">
                        <el-menu-item index="1">
                          <template slot="title">
                            <i class="el-icon-edit-outline"></i>&nbsp;<span class="title_level2">桥梁安全评价</span>
                          </template>
                        </el-menu-item>
                    </router-link>
                    <router-link to="/EvaluationSecond" class="link">
                        <el-menu-item index="2">
                          <template slot="title">
                            <i class="el-icon-edit-outline"></i>&nbsp;<span class="title_level2">隧道安全评价</span>
                          </template>
                        </el-menu-item>
                    </router-link>
                    <router-link to="/EvaluationThird" class="link">
                        <el-menu-item index="3">
                          <template slot="title">
                            <i class="el-icon-edit-outline"></i>&nbsp;<span class="title_level2">边坡安全评价</span>
                          </template>
                        </el-menu-item>
                    </router-link>
                  <router-link to="/EvaluationFourth" class="link">
                        <el-menu-item index="4">
                          <template slot="title">
                            <i class="el-icon-edit-outline"></i>&nbsp;<span class="title_level2">房屋安全评价</span>
                          </template>
                        </el-menu-item>
                    </router-link>
                </el-menu>
            </el-col>
            <el-col :span="20" class="full_height">
                <router-view class="full_height tab_content"></router-view>
            </el-col>
        </el-row>
<!--        <home-footer></home-footer>-->
    </div>
</template>

<script>
    // import HomeFooter from '../../components/Footer'

    export default {
        components: {
            // HomeFooter,
        },
        data() {
            return {

            };
        },
        mounted: function () {
            this.$router.push({"name": "EvaluationFirst"})
        }
    }
</script>

<style scoped>

    @import "../../assets/css/style.css";

    .title_level2{
        font: 14px  "Microsoft YaHei";
    }

</style>



// WEBPACK FOOTER //
// src/components/evaluation/index.vue